import {notEmpty} from '@/utils/index.js'
//千位符
export function thousandSeparator(value){
	if (!notEmpty(value)) return '';
	let formattedNumber = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return formattedNumber;
};
